import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import VolunteerDetails from './VolunteerDetails';
import VolunteerStep1 from './VolunteerStep1';
import VolunteerStep2 from './VolunteerStep2';
import VolunteerStep3 from './VolunteerStep3';
import VolunteerSuccess from './VolunteerSuccess';

const Volunteer = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(volunteer|volunteer/start)"
                            name="VolunteerDetails"
                            exact
                            component={VolunteerDetails}
                        />
                        <Route
                            path="/volunteer/step1"
                            name="VolunteerStep1"
                            exact
                            component={VolunteerStep1}
                        />
                        <Route
                            path="/volunteer/step2"
                            name="VolunteerStep2"
                            exact
                            component={VolunteerStep2}
                        />
                        <Route
                            path="/volunteer/step3"
                            name="VolunteerStep3"
                            exact
                            component={VolunteerStep3}
                        />
                        <Route
                            path="/volunteer/success"
                            name="VolunteerSuccess"
                            exact
                            component={VolunteerSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Volunteer;



// WEBPACK FOOTER //
// ./src/containers/Volunteer/Volunteer.jsx